module.exports = __webpack_public_path__ + "img/blockfi-dark.d445d92d.svg";